.banner-message {
  justify-content: center;
  border-radius: 0;
  border-style: solid;
  border-width: 1px 0;
  border-color: var(--primary--message--border-color--4);
}

.banner-message-text {
  width: auto;
}
